import { render, staticRenderFns } from "./hklhc.vue?vue&type=template&id=2d905082&scoped=true"
import script from "./hklhc.vue?vue&type=script&lang=js"
export * from "./hklhc.vue?vue&type=script&lang=js"
import style0 from "./hklhc.vue?vue&type=style&index=0&id=2d905082&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d905082",
  null
  
)

export default component.exports